import { library } from '@fortawesome/fontawesome-svg-core'
import { faCat } from "@fortawesome/free-solid-svg-icons"
import { faGithub, faGoogle, faTwitter, faResearchgate, faOrcid } from '@fortawesome/free-brands-svg-icons'
library.add(faCat, faGithub, faGoogle, faTwitter, faResearchgate, faOrcid)
// Now add the faCoffee icon to our library and we can use
// the string name 'coffee' in our app 
